import { DropdownArrowIcon } from 'components/common';
import { ClockIcon } from 'components/common/Icons';
import { useState } from 'react';
import { FormattedMessage } from 'react-intl';

export const HowLongMobileBlock = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className={'md:hidden'}>
      <div className={'border-pinky rounded-2.5xl border border-solid p-5'}>
        <div className={'flex justify-between'} onClick={() => setIsOpen(prev => !prev)}>
          <h3 className={'text-main font-satoshiBlack my-0 flex text-base font-black'}>
            <FormattedMessage
              id={'affordabilityCalculator.beforeStart.howLong'}
              values={{
                icon: <ClockIcon className={'my-auto mr-4 flex'} />,
              }}
            />
          </h3>
          <DropdownArrowIcon isOpen={isOpen} color={'primary'} />
        </div>

        {isOpen && (
          <div className={'text-ash font-satoshiMedium font-medium'}>
            <p className={'mb-0'}>
              <FormattedMessage
                id={'affordabilityCalculator.beforeStart.howLong.text1'}
                values={{
                  b: text => <b>{text}</b>,
                }}
              />
            </p>
            <p className={'mb-0'}>
              <FormattedMessage
                id={'affordabilityCalculator.beforeStart.howLong.text2'}
                values={{
                  b: text => <b>{text}</b>,
                }}
              />
            </p>
          </div>
        )}
      </div>
    </div>
  );
};
